import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BONOS, PRICING } from '../../data/content';
export function Bonos() {
  return <section className="relative w-full bg-ink-soft px-5 py-12 sm:py-16" data-id="element-17" data-mp="13jgbvq8sc668">
      <div className="mx-auto max-w-5xl" data-id="element-18" data-mp="1hiptmucn38cb">
        <h2 className="text-center font-display text-3xl leading-tight text-white sm:text-5xl" data-id="element-19" data-mp="1hhog8j85i9rf">
          🎁 5 Bonos Exclusivos — <span className="text-lime" data-id="element-20" data-mp="ov3in11311ff">Siempre Incluidos</span>
        </h2>

        <div className="mt-7 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="ot0tej7r7cbr">
          {BONOS.map(b => <article key={b.n} className="flex gap-3 rounded-xl border border-ink-border bg-ink-card p-3.5" data-id="element-22" data-mp="ju5ywk0fbzbt">
              <img src={b.mockup} alt={`Portada del Bono ${b.n}: ${b.title}`} width={192} height={256} loading="lazy" decoding="async" className="h-32 w-24 flex-shrink-0 self-center object-contain" data-id="element-23" data-mp="tu6mii5bt1lt" />
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-24" data-mp="2zaxf0amkoafq">
                <div className="flex items-center justify-between gap-2" data-id="element-25" data-mp="2z8l2iczl2sa2">
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-magenta/15 font-display text-sm text-magenta" data-id="element-26" data-mp="347xoywmjlxc4">
                    {b.n}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-lime px-2 py-1 text-[9px] font-extrabold uppercase text-ink" data-id="element-27" data-mp="3d10y4sq5no0y">
                    <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-28" data-mp="2lacw7egnqem8" /> Gratis
                  </span>
                </div>
                <h3 className="mt-2 text-sm font-bold leading-snug text-white" data-id="element-29" data-mp="2pb6mgehko5ia">{b.title}</h3>
                <p className="mt-1 flex-1 text-xs leading-snug text-white/65" data-id="element-30" data-mp="2ubkuvxn35hgu">{b.desc}</p>
                <p className="mt-2 text-xs text-white/40 line-through" data-id="element-31" data-mp="4mimkh109qcl">Valor {b.price}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-6 rounded-xl border border-lime/40 bg-lime/10 px-5 py-4 text-center" data-id="element-32" data-mp="9n6mxtb4jjjh">
          <p className="font-display text-lg text-white sm:text-xl" data-id="element-33" data-mp="25qbc12arhnqc">
            Bonos valuados en <span className="text-white/50 line-through" data-id="element-34" data-mp="21mdciqhiyawr">{PRICING.bonusValueOld}</span>{' '}
            <span className="text-lime" data-id="element-35" data-mp="2flw86jt5fts6">— incluidos gratis</span>
          </p>
        </div>
      </div>
    </section>;
}